import firebase, { boardsCollection } from "../firebase";
import { v4 as uuidv4 } from "uuid";
import { getCurrentUserId, logError } from "./../util/common";

class ColumnService {
  async updateWithCustomPayload(documentId, updatePayload) {
    return boardsCollection.doc(documentId).update(updatePayload);
  }

  async create(documentId) {
    const boardDocRef = boardsCollection.doc(documentId);

    // Every update, make sure card exist in db where it is supposed to be before updating.
    // If it no longer exist, we don't update.
    firebase
      .firestore()
      .runTransaction((transaction) => {
        return transaction.get(boardDocRef).then((boardDoc) => {
          if (!boardDoc.exists) {
            throw "Document does not exist!";
          }
          const dbBoardJSON = boardDoc.data();

          let currentMaxIndex;
          if (Object.keys(dbBoardJSON.columns).length === 0) {
            currentMaxIndex = -1;
          } else {
            currentMaxIndex = Math.max(
              ...(Object.values(dbBoardJSON.columns).map(
                (columnObject) => columnObject.index
              ) ?? [])
            );
          }

          const update = {};
          update[`columns.${uuidv4()}`] = {
            // Default values
            title: "New Column",
            index: currentMaxIndex + 1,
            cards: {},
            created_at: firebase.firestore.FieldValue.serverTimestamp(),
            created_by: getCurrentUserId(),
            updated_at: firebase.firestore.FieldValue.serverTimestamp(),
            updated_by: getCurrentUserId(),
          };
          return transaction.update(boardDocRef, update);
        });
      })
      .then(() => {
        console.log("Create Card Transaction successfully committed!");
      })
      .catch((error) => {
        console.error("Create Card Transaction failed: ", error);
        logError(error);
      });
  }

  async update(documentId, columnId, newTitle) {
    const boardDocRef = boardsCollection.doc(documentId);

    // Every update, make sure card exist in db where it is supposed to be before updating.
    // If it no longer exist, we don't update.
    firebase
      .firestore()
      .runTransaction((transaction) => {
        return transaction.get(boardDocRef).then((boardDoc) => {
          if (!boardDoc.exists) {
            throw "Document does not exist!";
          }
          const dbBoardJSON = boardDoc.data();

          if (dbBoardJSON.columns[columnId]) {
            const update = {};
            update[`columns.${columnId}.title`] = newTitle;
            return transaction.update(boardDocRef, update);
          } else {
            throw "Update column failed. The columns have changed since your last update";
          }
        });
      })
      .then(() => {
        console.log("Update column Transaction successfully committed!");
      })
      .catch((error) => {
        console.error("Update column Transaction failed: ", error);
        logError(error);
      });
  }

  async delete(documentId, columnId) {
    const update = {};
    update[`columns.${columnId}`] = firebase.firestore.FieldValue.delete();
    return boardsCollection.doc(documentId).update(update);
  }
}

export default new ColumnService();
